import { Toaster } from "sonner";
import { lazy, Suspense } from "react";
import "./App.css";
import "react-photo-view/dist/react-photo-view.css";
import { Footer } from "./components/footer/footer";
import { Header } from "./components/header/header";
import { ThemeProvider } from "./components/theme-provider/theme-provider";
import { MonthFlat } from "./components/month-flat/month-flat";

const HeroSliderLazy = lazy(
  () => import("./components/hero-slider/hero-slider"),
);
const OfferingSliderLazy = lazy(
  () => import("./components/offers-slider/offers-slider"),
);
const AdvantagesLazy = lazy(() => import("./components/advantages/advantages"));
const FlatLayoutsLazy = lazy(
  () => import("./components/flat-layouts/flat-layouts"),
);
const WhiteBoxSliderLazy = lazy(
  () => import("./components/white-box-slider/white-box-slider"),
);
const FinishingSliderLazy = lazy(
  () => import("./components/finishing-slider/finishing-slider"),
);
const PartnerLazy = lazy(() => import("./components/partner/partner"));
const LocationMapLazy = lazy(
  () => import("./components/location-map/location-map"),
);
const GalleryLazy = lazy(() => import("./components/gallery/gallery"));
const ParkingLazy = lazy(() => import("./components/parking/parking"));
const PurchasingLazy = lazy(() => import("./components/purchasing/purchasing"));
const BuildingProcessLazy = lazy(
  () => import("./components/building-process/building-process"),
);
const AboutDeveloperLazy = lazy(
  () => import("./components/about-developer/about-developer"),
);
const ContactsLazy = lazy(() => import("./components/contacts/contacts"));
const DispexSliderLazy = lazy(() => import("./components/dispex-slider/dispex-slider"));
const KeyHandoverVideoLazy = lazy(
  () => import("./components/key-handover-video/key-handover-video"),
);


function App() {
  return (
    <>
      <ThemeProvider defaultTheme={"dark"} storageKey={"ui-theme"}>
        <Toaster position="top-right" />
        <Header />
        <main className="bg-plt-white dark:bg-plt-bg overflow-x-hidden">
          {/*<Hero />*/}
          <HeroSliderLazy />
          <Suspense fallback={"loading..."}>
            {/*TODO open later*/}
            {/* <MonthFlat/> */}
            {/*<Offers />*/}
            <OfferingSliderLazy />
            <AdvantagesLazy />
            <FlatLayoutsLazy />
            <DispexSliderLazy />
            <KeyHandoverVideoLazy />
            <WhiteBoxSliderLazy />
            <FinishingSliderLazy />
            <PartnerLazy />
            <LocationMapLazy />
            <GalleryLazy />
            <ParkingLazy />
            <PurchasingLazy />
            <BuildingProcessLazy />
            <AboutDeveloperLazy />
            {/*<OurObjects />*/}
            <ContactsLazy />
          </Suspense>
        </main>
        <Footer />
      </ThemeProvider>
    </>
  );
}

export default App;
